import React from "react";

export const SectionTitle = ({title, labelId}) => {
    return <div className='section-title w-100 d-flex align-items-center my-3'>
            <h2 className="p-2 secondary-inverse--bg onsecondary-inverse--color secondary-font" style={{borderRadius:'1rem', fontSize:'1.5em'}} id={labelId}>{title}</h2>
            <div className="flex-grow-1 secondary-inverse--bg" style={{height:2}}></div>
    </div>
}
